import { set } from 'lodash/fp';
import { createReducer } from '@mews/framework';
import { WithProfileId } from '@mews-commander/types';
import { BOOKMARK_CAPTURED, BOOKMARK_CLEARED } from '../actions';
import { BookmarksState, IReportBookmark, WithAnalyticsType } from '../types';

const initialState: BookmarksState = {};

export default createReducer(initialState, {
    [BOOKMARK_CAPTURED]: (
        state: BookmarksState,
        {
            profileId,
            analyticsType,
            capturedBookmark,
        }: { capturedBookmark: IReportBookmark } & WithProfileId & WithAnalyticsType
    ) => set([profileId, analyticsType], capturedBookmark, state),
    [BOOKMARK_CLEARED]: (state: BookmarksState, { profileId, analyticsType }: WithProfileId & WithAnalyticsType) =>
        set([profileId, analyticsType], null, state),
});
